// Constants
import { STORAGE_DATA } from '@/constants/storageData'
import { ROUTE_PATH } from '@/constants/routePath'
import { envConfigs } from '@/constants/config'

// 舊會員（走 passport「由此登入」）的 SSO cookie：l_p_jwt(時效2h)/l_p_cc_0(時效9d)。
// 只清 localStorage token 不夠——passport session 還活著，下次碰 passport 會拿舊 cookie 直接放行、
// 不出登入表單（登出後又自動登入、要登入兩次的來源）。這兩個 cookie 非 httpOnly，登出時一併過期。
const PASSPORT_COOKIE_KEYS = ['l_p_jwt', 'l_p_cc_0']

const clearPassportCookies = () => {
  // cookie 掛在 envConfigs.cookieDomain(.tutorabcshop.com)；刪除要帶相同 domain 才會生效，
  // 另補當前 hostname 以防非標準網域（localhost 等）拒絕該 domain 的 cookie。
  const domains = [envConfigs?.cookieDomain, window.location.hostname].filter(Boolean)

  PASSPORT_COOKIE_KEYS.forEach((key) => {
    domains.forEach((domain) => {
      document.cookie = `${key}=; path=/; domain=${domain}; expires=Thu, 01 Jan 1970 00:00:00 GMT`
    })
  })
}

type HandleLogoutOptions = {
  // SDC-2275：自動登出不該強制把使用者踢回首頁；由呼叫端自行決定要不要 reload/導頁。
  redirect?: boolean
}

// login v2 已不走 passport 登出：清掉本地 session 相關 key ＋ passport SSO cookie 後硬導回首頁，
// reload 會讓 redux 會員態/購物車等整包重置（比只清 token 更乾淨，畫面也才會反應）
// 購物車 id 一律清掉：後端不再讓未登入者用會員車的 id 存取該車（回 -5002），
// 會員重新登入後由後端依 JWT 找回會員車，訪客期間加的品項也會併入，不需要前端保留 id。
const handleLogout = ({ redirect = true }: HandleLogoutOptions = {}) => {
  window.localStorage.removeItem(STORAGE_DATA.TOKEN)
  window.localStorage.removeItem(STORAGE_DATA.IS_TIMEOUT)
  window.localStorage.removeItem(STORAGE_DATA.SHOPPINGCART_ID)

  // 「領取特別禮」不再提醒是 per-帳號 key（profileGiftReminderDismissed:<memberInfoId>），登出時整批清掉
  Object.keys(window.localStorage)
    .filter((key) => key.startsWith(STORAGE_DATA.PROFILE_GIFT_REMINDER_DISMISSED))
    .forEach((key) => window.localStorage.removeItem(key))

  clearPassportCookies()

  if (redirect) {
    window.location.href = `${window.location.origin}${ROUTE_PATH.HOME}`
  }
}

export default handleLogout
